module.exports = __webpack_public_path__ + "static/media/mooring.8ba2b0a8.svg";